module.exports = __webpack_public_path__ + "img/rule-title.8314b73b.png";